const MeetingAction = {
    Leave: 'LEAVE',
    Start: 'START',
};
export default MeetingAction;
